//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import fieldBase from "@/mixins/field-base";
import "vue2-datepicker/index.css";

let parseDate = (date) => {
  if (date) {
    return new Date(Date.parse(date));
  }
};
export default {
  mixins: [fieldBase],
  components: {
    DatePicker: async () => import("vue2-datepicker").then((x) => x.default),
  },
  props: {
    fieldIndex: {
      required: false,
      default: "",
    },
    field: {
      required: true,
    },
    value: {
      required: true,
    },
    validationContext: {
      required: true,
    },
  },
  data() {
    return {
      localValue: this.value,
      key: 1,
      observer: null,
      arrowIconSrc: require('~/assets/icons/base/year-dropdown-arrow.svg')
    };
  },
  watch: {
    field: {
      handler(newValue) {
        if (this.localValue != this.value) {
          this.key = +this.key;
          this.localValue = this.value;
        }
      },
    },
  },
  computed: {
    // Written-date fields (meta.format "MMMM d, yyyy") must keep emitting the
    // long-form value so downstream consumers receive e.g. "November 5, 2010".
    valueType() {
      return this.field.isWrittenDate ? "format" : "YYYY-MM-DD";
    },
    displayFormat() {
      const raw = this.field.isWrittenDate
        ? "MMMM D, YYYY"
        : this.field.meta && this.field.meta.format
        ? this.field.meta.format
        : "M/D/YYYY";
      // Normalize Java/.NET-style tokens (lowercase y/d) to vue2-datepicker
      // tokens (uppercase Y/D). Without this, 'MM/dd/yyyy' renders as
      // '06/Th/yyyy' — dd becomes day-of-week short, yyyy stays literal.
      return raw.replace(/y/g, "Y").replace(/d/g, "D");
    },
  },
  methods: {
    onContext(ctx) {
      if (ctx.selectedFormatted != "No date selected") {
        // The date formatted in the locale, or the `label-no-date-selected` string
        this.localValue = ctx.selectedFormatted;
        this.$emit("input", this.localValue);
      }
    },
    updateDatePicker() {
      this.$emit("input", this.localValue);
    },
    onOpen() {
      this.setupYearIndicator();
      this.$nextTick(this.nameCalendar);
    },
    // Hindsight names the open calendar, so clicks on its days, months, years and arrows are keyed. vue2-datepicker
    // passes no attributes to its popup, so the name is set each time the popup renders. The popup is the input's
    // sibling, never around it, so the date's change never takes the name.
    nameCalendar() {
      const calendar = this.$el.querySelector(".mx-datepicker-main");
      if (calendar) calendar.setAttribute("data-hs-el", "form.date_calendar");
    },
    setupYearIndicator() {
      this.$nextTick(() => {
        const datepickerBody = document.querySelector('.mx-datepicker-body');
        if (!datepickerBody) return;

        this.addYearIndicator();

        if (this.observer) {
          this.observer.disconnect();
        }

        this.observer = new MutationObserver(() => {
          this.addYearIndicator();
        });

        this.observer.observe(datepickerBody, {
          childList: true,
          subtree: true
        });
      });
    },
    addYearIndicator() {
      const yearBtn = document.querySelector('.mx-btn-current-year');

      if (yearBtn && !yearBtn.classList.contains('year-indicator-added')) {
        yearBtn.classList.add('year-indicator-added');

        const arrowSpan = document.createElement('span');
        arrowSpan.className = 'year-dropdown-arrow';

        const imgElement = document.createElement('img');
        imgElement.src = this.arrowIconSrc;

        arrowSpan.appendChild(imgElement);
        yearBtn.appendChild(arrowSpan);
      }
    }
  },
  mounted() {
    this.setupYearIndicator();
  },
  beforeDestroy() {
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }
  }
};
